module.exports = __webpack_public_path__ + "img/icon_lock_remoteOpen.93c37103.svg";